export default {
  namespaced: true,
  state: {
    pageTitle: ''
  },
  getters: {},
  mutations: {
    UPDATE_PAGE_TITLE(state, val) {
      state.pageTitle = val;
    },
  },
  actions: {
    updatePageTitle({ commit }, payload) {
      commit('UPDATE_PAGE_TITLE', payload);
    },
  },
}
